import { WebApiRequest, HTTP_POST } from "tools/webservice";

export const requestAppraisalCoverage = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: "/sales/appraisal/estimated-volume-county",
  payload: payload,
  successCallback,
  mountedRef,
});

export const sendClickTrackingEmail = (customerNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: "/sales/appraisal/click-tracking",
  payload: customerNumber,
  successCallback,
  mountedRef,
});